import { ApiService } from '@/apiConnection/ApiService';
import { Urls } from '@/apiConnection/urls';
import { CustomInputComponent } from '@/components/custom-input/custom-input.component';
import { CustomModalComponent } from '@/components/custom-modal/custom-modal.component';
import { LoadingComponent } from '@/components/loading/loading.component';
import { Utils } from '@/utils/utils';
import { ProductTypeAttributesComponent } from '../product-type-attributes/product-type-attributes.component';
import { Component, Input, Output, EventEmitter, ChangeDetectorRef, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';


@Component({
  selector: 'app-product-type-form',
  imports: [
    CustomModalComponent,
    ReactiveFormsModule,
    CustomInputComponent,
    LoadingComponent,
    ProductTypeAttributesComponent,
  ],
  templateUrl: './product-type-form.component.html',
  styleUrl: './product-type-form.component.scss',
})
export class ProductTypeFormComponent {
  @Input() id: number | string = 0;
  @Output() closeFunction = new EventEmitter<any>();
  @Output() acceptFunction = new EventEmitter<any>();

  public loading = signal(false);
  public saving = signal(false);

  public saveForm: FormGroup = new FormGroup({});

  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.createForm();

    if (this.id != 0) {
      this.getById(this.id);
    }
  }

  acceptFormFunction() {
    this.saveEntity()
  }

  closeFormFunction() {
    this.closeFunction.emit();
  }

  createForm() {
    this.saveForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      has_allergens: new FormControl(false),
      stock_control: new FormControl(false),
    })
  }

  getById(id: number | string) {
    this.loading.set(true);
    this.apiService.getById(Urls.urls.productTypes, id).subscribe({
      next: (data: any) => {
        this.saveForm.patchValue(data);
        this.loading.set(false);

        this.cdr.detectChanges();
      },
      error: (error: any) => {
        console.error('ERROR obtener tipos de producto. ' + error);
        this.loading.set(false);
      },
      complete: () => {
        this.loading.set(false);
      },
    });
  }

  saveEntity() {
    if (this.saveForm.valid) {
      this.saving.set(true);

      this.apiService.save(Urls.urls.productTypes, this.saveForm.value, this.id).subscribe({
        next: (response: any) => {
          Utils.notification.success("Tipo de producto guardado")
          this.acceptFunction.emit(response);
          this.closeFormFunction()
        },
        error: (error: any) => {
          this.saving.set(false);
          Utils.notification.alert(Utils.extractErrorMessage(error) || "Error al guardar el tipo de producto")
        },
        complete: () => {
          this.saving.set(false);
        }
      })
    } else {
      Utils.notification.alert("Debe completar todos los campos obligatorios")
    }
  }

}
